// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swrzY8VJ6PUyNDiJ{border-radius:1000px}.vLb1Jgt3HFMsLxFe{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block}.MmDmxPCXaRkXBL_t{display:flex;flex-direction:column;justify-content:center;align-items:center}.RTtHg6vGi4qe66cC{animation:roig0jT64bUMdQDW 3s infinite;animation-iteration-count:infinite}@keyframes roig0jT64bUMdQDW{0%{background:var(--py-neutral-1)}30%{background:var(--py-neutral-1)}50%{background:var(--py-neutral-1)}80%{background:var(--py-neutral-1)}100%{background:var(--py-neutral-1)}}.kcYktz8ruzI2CI2K label{display:inline-block;vertical-align:top}.kcYktz8ruzI2CI2K .V3jFnjdHdYY9QP5Z{margin-left:5px;color:rgb(139.2,188.4,217.8);display:inline-block;vertical-align:top}.kcYktz8ruzI2CI2K .V3jFnjdHdYY9QP5Z:hover{color:#3e90c1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"circle": `swrzY8VJ6PUyNDiJ`,
	"text-truncate": `vLb1Jgt3HFMsLxFe`,
	"shaquille": `MmDmxPCXaRkXBL_t`,
	"shimmer": `RTtHg6vGi4qe66cC`,
	"placeHolderShimmer": `roig0jT64bUMdQDW`,
	"labelContainer": `kcYktz8ruzI2CI2K`,
	"tooltipBox": `V3jFnjdHdYY9QP5Z`
};
export default ___CSS_LOADER_EXPORT___;
